module.exports = __webpack_public_path__ + "img/77422.25bee7a0.svg";